<template>
    <span>
        <h6 class="heading6 mb-0" v-if="getPromotionCost(product)">
            <span class="text_primary_red mr_18">
                As low as ${{ discountedPrice(product) }}
            </span>
            <span class="text_light_grey">
                ${{ getRetailPrice(product) }}
            </span>
        </h6>
        <h6 class="heading6 mb-0" v-else>
            <span class="text_primary_red mr_18">
                As low as ${{ getRetailPrice(product) }}
            </span>
        </h6>
    </span>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Productoffer",
    /* eslint-enable */
    props: {
        product: {
            required: true
        },
        tShirt24Hour: {
            required: false,
            default: () => false
        }
    },
    methods: {
        discountedPrice(product) {
            let promotion_values = product.MainNewProductDiscount;
            let final_price = 0;
            if (!promotion_values) {
                return final_price;
            }
            let retail_price = Number(this.getRetailPrice(product));
            let discount_value = Number(promotion_values.discount_value);
            if (promotion_values.discount_type == "Percent") {
                final_price = retail_price * ((100 - discount_value) / 100);
            } else {
                final_price = retail_price - discount_value;
            }

            return final_price.toFixed(2);
        },
        getPromotionCost(product) {
            let promotion_values = product.MainNewProductDiscount;
            if (!promotion_values) {
                return;
            }
            var today = new Date();
            var enddate = new Date(promotion_values.end_date);
            var startdate = new Date(promotion_values.start_date);

            let returnvalue = "";

            if (enddate >= today && startdate <= today) {
                if (promotion_values.discount_value) {
                    returnvalue = Number(
                        promotion_values.discount_value
                    ).toFixed(2);
                }

                if (promotion_values.discount_type == "Flat") {
                    returnvalue = "-$" + returnvalue;
                } else {
                    returnvalue = "-" + returnvalue + "%";
                }
            }
            return returnvalue;
        },
        getRetailPrice(product) {
            let product_cost = product.price_base;
            let markup_value = product.price_markup_value;
            let single_location_cost = 0;
            let discount = 0;
            let retail_price = 0;
            if (product.decoration_type == 1) {
                let decoration_prices = JSON.parse(
                    product.price_decoration_bulk
                )["print_location1"];
                decoration_prices.forEach((decoration, i) => {
                    if (i == 0) {
                        single_location_cost = decoration.colour1;
                    } else if (
                        parseFloat(single_location_cost) >
                        parseFloat(decoration.colour1)
                    ) {
                        single_location_cost = decoration.colour1;
                    }
                });
            } else if (product.decoration_type == 2) {
                let decoration_prices = JSON.parse(
                    product.price_decoration_bulk
                );
                decoration_prices.forEach((decoration, i) => {
                    if (i == 0) {
                        single_location_cost = decoration.cost;
                        discount = decoration.discount;
                    } else if (
                        parseFloat(single_location_cost) >
                        parseFloat(decoration.cost)
                    ) {
                        single_location_cost = decoration.cost;
                        discount = decoration.discount;
                    }
                });
            }
            product.single_location_cost = single_location_cost;

            product.decoration_discount = discount;

            if (product.MainNewSubProducts.length > 0) {
                // This is termparary code. Because in admin side product have issue with default color having some duplicate colors
                let sub_products = [];
                if (!this.tShirt24Hour) {
                    sub_products = product.MainNewSubProducts.filter(
                        (subProduct) => subProduct.default_selection == 1
                    );
                } else {
                    sub_products = product.MainNewSubProducts.filter(
                        (subProduct) => subProduct.Color.name == "White"
                    );
                }
                if (sub_products.length > 0) {
                    let sub_product = sub_products[sub_products.length - 1];
                    if (sub_product) {
                        if (sub_product.Color.category == "Dark") {
                            retail_price += parseFloat(
                                product.price_color_category_dark
                            );
                        } else if (sub_product.Color.category == "Light") {
                            retail_price += parseFloat(
                                product.price_color_category_light
                            );
                        }
                    }
                }
            }

            retail_price +=
                parseFloat(product_cost) +
                parseFloat(markup_value) +
                parseFloat(single_location_cost);

            if (isNaN(retail_price)) {
                retail_price = 0.0;
            }

            if (product.decoration_type == 2) {
                retail_price = retail_price - (retail_price * discount) / 100;
            }
            return this.icPriceFormat(retail_price, true);
        }
    }
};
</script>
